<template>
    <div>
        <div v-for="agreement in agreementInputs" class="form-check mb-0">
            <input class="form-check-input" v-bind:class="'form-control ' + (hasError(agreement.id) ? 'error-input' : '')" type="checkbox" :value="agreement.id" :id="agreement.id" @input="updateValue($event.target.value)">
            <label class="form-check-label form-check-label--small align-content-center justify-content-start" :for="agreement.id">
                <span v-if="agreement.required">*</span> <span class="d-inline mb-0" v-html="agreement.content"/>
            </label>
            <div class="error" v-if="hasError(agreement.id)">
                <br/>
                <ul>
                    <li>Prosimy zaznaczyć wymaganą zgodę</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['name', 'errorMessages', 'agreementInputs'],

    methods: {
        updateValue(value) {
            if(Array.isArray(this.value) && value in this.value) {
                if(this.value[value] === true) {
                    this.value[value] = false;
                } else {
                    this.value[value] = true;
                }
            } else {
                if(!Array.isArray(this.value)) {
                    this.value = [];
                }
                this.value[value] = true;
            }

            this.$emit('input', this.value);

            var key = 'agreements.' + value;
            if(this.errorMessages !== null && key in this.errorMessages) {
                this.errorMessages[key] = null;
            }
            if(this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        },
        hasError(id) {
            var key = 'agreements.' + id;
            if(this.errorMessages !== null && key in this.errorMessages) {
                return true;
            }

            return false;
        }
    },
    data() {
        return {
            value: []
        };
    },
    watch: {
        errorMessages: function (newValue, oldValue) {
            this.$forceUpdate();
        }
    }

}
</script>
